import React, { useEffect, useRef, useState } from "react";
import Sidebar from "../Reusables/Sidebar";
import Navbar from "../Reusables/Navbar";
import Tables from "../Reusables/Table";
import { ReactComponent as Search } from "./../../assets/Search.svg";
import { ReactComponent as Download } from "./../../assets/Download.svg";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { ReactComponent as Calendar } from "../../assets/calendar.svg";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Transactions } from "../Store/Apis/Transactions";
import toast from "react-hot-toast";
import Pagination from "../Reusables/Pagination";
import empty from "../../assets/empty.png";
import { Loader } from "./Loader";
import AppUserModal from "../../Modal/AppUserModal";
import { DownloadAdminTrans } from "../Store/Apis/DownloadAdminTrans";
import { DownloadSummary } from "../Store/Apis/DownloadSummary";
import { DownloadEkoReport } from "../Store/Apis/DownloadEkoReport";

const Transfers = ({ title }) => {
  const [whitecrust, setWhitecrust] = useState(true);
  const [other, setOther] = useState(false);
  const [postsPerPage, setPostsPerPage] = useState(10);
  const [activater, setActivater] = useState(1);
  const [currentPage, setCurrentPage] = useState(0);
  const [loading, setloading] = useState(false);
  const [searcher, setSearcher] = useState("");
  const [startDate, setStartDate] = useState(new Date("2022-01-01"));
  const [downloading, setDownload] = useState([]);
  const [reload, setReload] = useState(false);
  const [step, setStep] = useState(0);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const White = () => {
    setWhitecrust(true);
    setOther(false);
  };

  const Othering = () => {
    setWhitecrust(false);
    setOther(true);
  };

  const [endDate, setEndDate] = useState(
    new Date(Date.now() + 3600 * 1000 * 24)
  );
  const datePickerRef = useRef(null);
  const datePickerRefs = useRef(null);

  const dateChange = (date) => {
    console.log(date);
    setEndDate(date);
  };

  const dateChanger = (date) => {
    console.log(date);
    setStartDate(date);
  };

  const PickDate = () => {
    datePickerRef.current.setOpen(true);
  };

  const PickDater = () => {
    datePickerRefs.current.setOpen(true);
  };

  useEffect(() => {
    if (sessionStorage.getItem("token")) {
      dispatch(Transactions({ startDate, searcher, currentPage, endDate }));
      dispatch(DownloadAdminTrans({ startDate, searcher, endDate }));
      dispatch(DownloadSummary({ startDate, searcher, endDate }));
      dispatch(DownloadEkoReport({ startDate, endDate }));
      return;
    } else {
      navigate("/");
      toast.error("You aren't logged in");
    }

    //eslint-disable-next-line
  }, [startDate, searcher, currentPage, endDate]);

  const { transactions, authenticatingtransactions } = useSelector(
    (state) => state?.transactions
  );
  console.log(transactions);

  const { downloadadmintrans, authenticatingdownloadadmintrans } = useSelector(
    (state) => state?.downloadadmintrans
  );
  console.log(downloadadmintrans);

  const { downloadsummary, authenticatingdownloadsummary } = useSelector(
    (state) => state?.downloadsummary
  );
  console.log(downloadsummary);

  const { downloadekoreport, authenticatingdownloadekoreport } = useSelector(
    (state) => state?.downloadekoreport
  );
  console.log(downloadekoreport);

  useEffect(() => {
    if (transactions?.data) {
      setTimeout(() => {
        setloading(true);
      }, [2000]);
    }
  }, [transactions?.data]);

  const next = transactions?.data?.meta?.next;
  const previous = transactions?.data?.meta?.prev;
  const totalPosts = transactions?.data?.meta?.totalCount;

  const paginate = (number) => {
    //  setSorted(tran)
    setCurrentPage(number - 1);
    setActivater(number);
  };

  const Downloading = () => {
    console.log("sodiq");
    const data = downloadadmintrans || [];
    if (data.length === 0) {
      toast.error("You can't download an empty file");
      return;
    }
    if (data.length === 0) return;
    const headers = Object.keys(data[0]);
    const rows = data.map((item) =>
      headers.map((header) => item[header] || "")
    );
    const csvContent = [
      headers.join(","),
      ...rows.map((row) => row.join(","))
    ].join("\n");
    const blob = new Blob([csvContent], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "Transactions.csv";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  const DownloadingSummary = () => {
    console.log("summary");
    const data = downloadsummary || [];
    if (data.length === 0) {
      toast.error("You can't download an empty file");
      return;
    }
    if (data.length === 0) return;
    const headers = Object.keys(data[0]);
    const rows = data.map((item) =>
      headers.map((header) => item[header] || "")
    );
    const csvContent = [
      headers.join(","),
      ...rows.map((row) => row.join(","))
    ].join("\n");
    const blob = new Blob([csvContent], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "Transactions Summary.csv";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  const DownloadingEko = () => {
    console.log("summary");
    const data = downloadekoreport || [];
    if (data.length === 0) {
      toast.error("You can't download an empty file");
      return;
    }
    if (data.length === 0) return;
    const headers = Object.keys(data[0]);
    const rows = data.map((item) =>
      headers.map((header) => item[header] || "")
    );
    const csvContent = [
      headers.join(","),
      ...rows.map((row) => row.join(","))
    ].join("\n");
    const blob = new Blob([csvContent], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "Eko Transactions Report.csv";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  return (
    <div className="flex flex-row">
      <div className="w-[15%] h-[100%]">
        <Sidebar />
      </div>
      <div className="flex flex-col w-[85%] h-[100%]">
        <div className="w-[100%] h-[20%]">
          <Navbar title={title} />
          <AppUserModal
            // setaction={setaction}
            // action={actions}
            // userIds={userIds}
            // setuserIding={setuserIding}
            // userIding={userIding}
            // setUserIds={setUserIds}
            setDownload={setDownload}
            downloading={downloading}
            setStep={setStep}
            step={step}
            setReload={setReload}
          />
        </div>
        <div className="w-[100%] py-9 px-5 flex flex-col gap-10">
          <div className="flex flex-row justify-between">
            <span className="text-route-name text-[28px] font-semibold">
              Transactions
            </span>
            <div className="relative flex flex-row w-[50%]">
              <div className="absolute top-3 left-4">
                <Search />
              </div>
              <input
                className="border-input-color border-[1px] rounded-tl-custom rounded-bl-custom w-[85%] outline-none pl-[60px] text-[13px]"
                placeholder="Search by Phone number, account number, meter Number"
                value={searcher}
                onChange={(e) => {
                  setSearcher(e.target.value);
                  setCurrentPage(0);
                  setActivater(1);
                }}
              />
              <button className="bg-route-color w-[15%] rounded-tr-custom rounded-br-custom text-white font-semibold text-[12px]">
                Search
              </button>
            </div>
          </div>
          <div className="flex flex-col border-input-color border-[1px] rounded-custom py-4 gap-6">
            <div className="flex flex-row justify-end gap-4 px-3">
              {/* <div className="flex flex-col">
                <div className="flex flex-row gap-4 text-[14px] items-center text-route-noncolor font-medium">
                  <span
                    onClick={() => White()}
                    className={`${
                      whitecrust
                        ? "text-route-color cursor-pointer"
                        : "text-route-noncolor cursor-pointer"
                    }`}
                  >
                    To Paymeter Account
                  </span>
                  <span
                    onClick={() => Othering()}
                    className={`${
                      other
                        ? "text-route-color cursor-pointer"
                        : "text-route-noncolor cursor-pointer"
                    }`}
                  >
                    To Other banks
                  </span>
                </div>
                <div className="gap-4">
                  {whitecrust && (
                    <div className="w-[150px] h-[2px] bg-route-color" />
                  )}
                  {other && (
                    <div className="w-[100px] h-[2px] bg-route-color ml-[62%]" />
                  )}
                </div>
              </div> */}
              <div className="flex flex-row justify-end gap-4 px-4">
                <div className="position:relative z-40 w-[140px] h-[35px] rounded-custom px-[5px] flex flex-row border items-center">
                  <DatePicker
                    className="text-[10px] outline-none"
                    selected={startDate}
                    onChange={(date) => dateChanger(date)}
                    ref={datePickerRef}
                    showTimeSelect={false}
                    dateFormat="MMM d yyyy" // Use format tokens to represent "Oct 13 2023"
                    placeholderText="13 Oct 2023"
                    popperPlacement="bottom-start"
                  />
                  <Calendar
                    className="text-[10px]"
                    onClick={() => PickDate()}
                  />
                </div>
                <div className="position:relative z-40 w-[140px] h-[35px] rounded-custom px-[5px] flex flex-row border items-center">
                  <DatePicker
                    className="text-[10px] outline-none"
                    selected={endDate}
                    onChange={(date) => dateChange(date)}
                    ref={datePickerRefs}
                    showTimeSelect={false}
                    dateFormat="MMM d yyyy" // Use format tokens to represent "Oct 13 2023"
                    placeholderText="13 Oct 2023"
                    popperPlacement="bottom-start"
                  />
                  <Calendar
                    className="text-[10px]"
                    onClick={() => PickDater()}
                  />
                </div>
                {/* <input
                  type="date"
                  className="border-input-color border-[1px] rounded-custom  w-[117px] h-[36px] outline-none px-[10px] text-[11px]"
                  placeholder="Search by name, customerID, account number, transaction reference"
                />
                <input
                  type="date"
                  className="border-input-color border-[1px] rounded-custom  w-[117px] h-[36px] outline-none px-[10px] text-[11px]"
                  placeholder="Search by name, customerID, account number, transaction reference"
                /> */}
                <button
                  onClick={() => Downloading()}
                  className="px-2 h-[35px] flex flex-row gap-1 items-center bg-route-color  rounded-custom text-white font-semibold text-[11px]"
                >
                  Download Report <Download />
                </button>
                <button
                  onClick={() => DownloadingEko()}
                  className="px-1 h-[35px] flex flex-row gap-1 items-center bg-route-color rounded-custom text-white font-semibold text-[11px]"
                >
                  {authenticatingdownloadekoreport
                    ? "Downloading..."
                    : "Download Eko Report"}
                  {/* <Download /> */}
                </button>
                <button
                  onClick={() => DownloadingSummary()}
                  className="px-1 h-[35px] flex flex-row gap-1 items-center bg-route-color  rounded-custom text-white font-semibold text-[11px]"
                >
                  {authenticatingdownloadsummary
                    ? "Downloading..."
                    : "Download Summary"}
                  {/* <Download /> */}
                </button>
              </div>
            </div>
            {loading ? (
              <>
                {transactions?.data?.data?.length >= 1 && (
                  <Tables
                    setDownload={setDownload}
                    setStep={setStep}
                    currentPage={currentPage}
                    transfers
                    data={transactions?.data?.data}
                  />
                )}{" "}
                {!transactions?.status && (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center"
                    }}
                  >
                    <img src={empty} alt="empty" />
                  </div>
                )}
                {transactions?.data?.data?.length >= 1 && (
                  <Pagination
                    set={activater}
                    currentPage={currentPage}
                    postsPerPage={postsPerPage}
                    totalPosts={totalPosts}
                    paginate={paginate}
                    previous={previous}
                    next={next}
                  />
                )}
              </>
            ) : (
              <Loader />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Transfers;
